<template>
  <div class="footer">
    <el-row type="flex" align="middle" justify="center">
      <el-col :span="4" class="logo_image">
        <el-image :src="logo"></el-image>
      </el-col>
      <el-col :span="7" :offset="1">
        <p class="left_text text_14"><el-link type="primary" @click.native="navToAboutus">关于我们</el-link>&nbsp;&nbsp;|&nbsp;&nbsp;<el-link type="primary" @click.native="navToContactus">联系我们</el-link></p>
        <p class="left_text text_12">地址：泰安高新区中天门大街1366号</p>
        <p class="left_text text_12">版权所有 泰盈科技集团股份有限公司 2022 网站备案号：<a target="_blank" href="https://beian.miit.gov.cn/">鲁ICP备16023615号-3</a> <a href="http://www.miit.gov.cn/" target="_blank">增值电信业务经营许可证：B2-20120269</a> <el-image :src="beian" style="width: 1.58rem;height: 1.58rem;"></el-image><a href="https://beian.mps.gov.cn/#/query/webSearch?code=37099202000427" rel="noreferrer" target="_blank">鲁公网安备37099202000427号</a></p>
      </el-col>
      <el-col :span="4">
        <p class="right_text text_14">服务支持</p>
        <p class="right_text text_14">40018-40088</p>
        <p class="right_text text_12">周一至周日 08:00-23:00</p>
        <p class="right_text text_12">邮箱：majiaqing@ccrc.com</p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: 'baseFooter',
    data() {
      return {
        logo: require('../../assets/base/logo_kfb.png'),
		beian: require('../../assets/admin/beian.png')
      }
    },
    mounted() {
    },
    created() {
    },
    computed: {},
    methods: {
		navToAboutus(){
			this.$router.push("/aboutus")
		},
		navToContactus(){
			this.$router.push("/contactus")
		},
	}
  }
</script>
<style scoped>
  .footer {
    height: 100%;
    padding: 0;
    margin: 0;
    background-color: #1a1e27;
    font-size: 14px;
    color: #f0f0f0;
  }

  ul {
    list-style-type: none;
  }

  a, a:hover, a:visited, a:active, a:link {
    color: #f0f0f0;
    text-decoration-line: none;
  }

  .el-row{
    height: 100%;
  }

  .el-image {
    width: 197px;
    height: 154px;
  }

  .logo_image{
    height: 154px;
    text-align: left;
  }

  .left_text {
    text-align: left;
  }

  .text_12 {
    font-size: 14px;
  }

  .right_text {
    text-align: right;
  }

  .text_14 {
    font-size: 16px;
    font-weight: bold;
  }

  .text_16 {
    font-size: 18px;
    font-weight: bold;
  }
</style>